import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import marketing_45params_45global from "/opt/buildhome/repo/middleware/marketing-params.global.ts";
import region_45middleware_45global from "/opt/buildhome/repo/middleware/region-middleware.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  marketing_45params_45global,
  region_45middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  home: () => import("/opt/buildhome/repo/middleware/home.ts")
}